import React from "react";
import { PropTypes } from "prop-types";
import { MrbFieldInput, MrbFieldToggle, MrbEditPage } from "mrb/components";
import { MrbFieldSelect } from "mrb/components/select";
import { MrbContentLoader } from "mrb/components/loader";
import { defaultTemplate } from "common/hoc";
import { AdminCertifiedModeEditLoader } from "administration/certified-mode/components";

function AdminCertifiedModeEditTemplate({ adminCertifiedModeEditViewStore, t }) {
    const { form, loaderStore, certifierSelectStore } = adminCertifiedModeEditViewStore;

    return (
        <MrbEditPage store={adminCertifiedModeEditViewStore} t={t}>
            <div className="c-container--base">
                <div className="c-card--primary">
                    <MrbContentLoader loaderStore={loaderStore} loaderRender={() => <AdminCertifiedModeEditLoader />}>
                        {() => (
                            <div className="u-animation--fadeIn">
                                <div className="c-toggle__card-list u-mar--bottom--sml">
                                    <MrbFieldToggle
                                        classNameExtend="c-toggle__item--inline"
                                        t={t}
                                        field={form.$("isActive")}
                                    />
                                </div>
                                <div className="c-toggle__card-list u-mar--bottom--sml">
                                    <MrbFieldToggle
                                        classNameExtend="c-toggle__item--inline"
                                        t={t}
                                        field={form.$("allowNonCertifiedContent")}
                                    />
                                </div>
                                <MrbFieldInput t={t} field={form.$("name")} classNameExtend="c-input--outline" />
                                <MrbFieldSelect t={t} store={certifierSelectStore} classNameExtend="c-dropdown--dark" />
                            </div>
                        )}
                    </MrbContentLoader>
                </div>
            </div>
        </MrbEditPage>
    );
}

AdminCertifiedModeEditTemplate.propTypes = {
    adminCertifiedModeEditViewStore: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
};

export default defaultTemplate(AdminCertifiedModeEditTemplate);
